import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const Image = styled.img`
  width: 250px;
  height: 250px;
`;

export const Container = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const InfoContainer = styled(FlexContainer)`
  width: 337px;
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_success};
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
  svg {
    width: 100%;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
  }
  button {
    width: 50%;
  }
`;

export const TextContainer = styled(FlexContainer)`
  padding: ${({ theme: { system } }) => system.fds_sys_spacing_XS};
  svg {
    width: 50%;
  }
  span {
    color: ${({ theme: { components } }) => components.messages.fds_c_messages_success_strong};
    font-weight: bold;
  }
`;
